import { cloneDeep, isEqual } from 'lodash'

import { timeToArrayOfNumbers } from '../misc'
import { proxy } from './proxy'

const timeOptions = {
  hour12: false,
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
}

const createdAtKeyMapping = {
  legacy: {
    gt: '$gt',
    lt: '$lt'
  },
  nest: {
    gt: 'gte',
    lt: 'lt'
  }
}

const convertDateTime = ({ date, time }, backendGeneration = 'legacy') => {
  const result = {
    [createdAtKeyMapping[backendGeneration].gt]: undefined,
    [createdAtKeyMapping[backendGeneration].lt]: undefined
  }

  let _gt
  if (date[0]) {
    _gt = new Date(date[0])
  }
  let _lt
  if (date[1]) {
    _lt = new Date(date[1])
  } else if (_gt) {
    _lt = new Date(_gt)
  }

  if (_gt && _lt && time.$gt && time.$lt) {
    _gt.setHours(...timeToArrayOfNumbers(time.$gt))
    _lt.setHours(...timeToArrayOfNumbers(time.$lt))

    result[createdAtKeyMapping[backendGeneration].gt] = _gt.toISOString()
    result[createdAtKeyMapping[backendGeneration].lt] = _lt.toISOString()
  }

  return result
}
const convertDateToHammerTime = (date, locale) => {
  return date.toLocaleTimeString(locale, timeOptions)
}

export const defaultInputValue = {
  date: [],
  time: {}
}

export const createdAtFilter = {
  mixins: [ proxy({ type: 'object' }) ],

  props: {
    backendGeneration: {
      type: String,
      default: 'legacy',
      validator: value => {
        return [ 'legacy', 'nest' ].includes(value)
      }
    }
  },

  methods: {
    _inputFilter(data) {
      const value = cloneDeep(data)
      const result = cloneDeep(defaultInputValue)

      const _gt = value[createdAtKeyMapping[this.backendGeneration].gt]
      const _lt = value[createdAtKeyMapping[this.backendGeneration].lt]

      let gt
      if (_gt) {
        gt = new Date(_gt)
      }
      let lt
      if (_lt) {
        lt = new Date(_lt)
      }

      if (gt) {
        result.date.push(gt.getTime())
        result.time.$gt = convertDateToHammerTime(gt, this.locale)
      }
      if (lt) {
        result.date.push(lt.getTime())
        result.time.$lt = convertDateToHammerTime(lt, this.locale)
      }

      return result
    },

    _outputFilter(data) {
      return convertDateTime(data, this.backendGeneration)
    },

    watchProxyHandler() {
      const value = cloneDeep(this.value)
      const converted = convertDateTime(cloneDeep(this.proxy), this.backendGeneration)

      if (
        !isEqual(
          value[createdAtKeyMapping[this.backendGeneration].gt],
          converted[createdAtKeyMapping[this.backendGeneration].gt]
        ) ||
        !isEqual(
          value[createdAtKeyMapping[this.backendGeneration].lt],
          converted[createdAtKeyMapping[this.backendGeneration].lt]
        )
      ) {
        this.transmitValue()
      }
    }
  }
}
